import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Token_BEGIN_ARRAY_instance;
var Token_END_ARRAY_instance;
var Token_BEGIN_OBJECT_instance;
var Token_END_OBJECT_instance;
var Token_NAME_instance;
var Token_STRING_instance;
var Token_NUMBER_instance;
var Token_LONG_instance;
var Token_BOOLEAN_instance;
var Token_NULL_instance;
var Token_END_DOCUMENT_instance;
var Token_ANY_instance;
var Token_entriesInitialized;
function Token_initEntries() {
  if (Token_entriesInitialized)
    return Unit_instance;
  Token_entriesInitialized = true;
  Token_BEGIN_ARRAY_instance = new (Token())('BEGIN_ARRAY', 0);
  Token_END_ARRAY_instance = new (Token())('END_ARRAY', 1);
  Token_BEGIN_OBJECT_instance = new (Token())('BEGIN_OBJECT', 2);
  Token_END_OBJECT_instance = new (Token())('END_OBJECT', 3);
  Token_NAME_instance = new (Token())('NAME', 4);
  Token_STRING_instance = new (Token())('STRING', 5);
  Token_NUMBER_instance = new (Token())('NUMBER', 6);
  Token_LONG_instance = new (Token())('LONG', 7);
  Token_BOOLEAN_instance = new (Token())('BOOLEAN', 8);
  Token_NULL_instance = new (Token())('NULL', 9);
  Token_END_DOCUMENT_instance = new (Token())('END_DOCUMENT', 10);
  Token_ANY_instance = new (Token())('ANY', 11);
}
var TokenClass;
function Token() {
  if (TokenClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Token');
    TokenClass = $;
  }
  return TokenClass;
}
function Token_BEGIN_ARRAY_getInstance() {
  Token_initEntries();
  return Token_BEGIN_ARRAY_instance;
}
function Token_END_ARRAY_getInstance() {
  Token_initEntries();
  return Token_END_ARRAY_instance;
}
function Token_BEGIN_OBJECT_getInstance() {
  Token_initEntries();
  return Token_BEGIN_OBJECT_instance;
}
function Token_END_OBJECT_getInstance() {
  Token_initEntries();
  return Token_END_OBJECT_instance;
}
function Token_NAME_getInstance() {
  Token_initEntries();
  return Token_NAME_instance;
}
function Token_STRING_getInstance() {
  Token_initEntries();
  return Token_STRING_instance;
}
function Token_NUMBER_getInstance() {
  Token_initEntries();
  return Token_NUMBER_instance;
}
function Token_LONG_getInstance() {
  Token_initEntries();
  return Token_LONG_instance;
}
function Token_BOOLEAN_getInstance() {
  Token_initEntries();
  return Token_BOOLEAN_instance;
}
function Token_NULL_getInstance() {
  Token_initEntries();
  return Token_NULL_instance;
}
function Token_END_DOCUMENT_getInstance() {
  Token_initEntries();
  return Token_END_DOCUMENT_instance;
}
function Token_ANY_getInstance() {
  Token_initEntries();
  return Token_ANY_instance;
}
function ignoreUnknownKeys(ignoreUnknownKeys) {
}
function ignoreUnknownKeys_0() {
  return true;
}
var JsonReaderClass;
function JsonReader() {
  if (JsonReaderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'JsonReader');
    JsonReaderClass = $;
  }
  return JsonReaderClass;
}
//region block: exports
export {
  JsonReader as JsonReaderhn8ohc8v7l9p,
  Token_ANY_getInstance as Token_ANY_getInstance9hqrmgh2e8rx,
  Token_BEGIN_ARRAY_getInstance as Token_BEGIN_ARRAY_getInstanceq6fmixkefrta,
  Token_BEGIN_OBJECT_getInstance as Token_BEGIN_OBJECT_getInstanceif3n49bygvyp,
  Token_BOOLEAN_getInstance as Token_BOOLEAN_getInstance145ap4wnd8afw,
  Token_END_ARRAY_getInstance as Token_END_ARRAY_getInstance3mpk3gmigb9kl,
  Token_END_DOCUMENT_getInstance as Token_END_DOCUMENT_getInstance2vm30j439b0cy,
  Token_END_OBJECT_getInstance as Token_END_OBJECT_getInstance2x8wxmu47aqr2,
  Token_LONG_getInstance as Token_LONG_getInstance1q4dpv6tjhcl0,
  Token_NAME_getInstance as Token_NAME_getInstance1jn9wytcokkr3,
  Token_NULL_getInstance as Token_NULL_getInstance1u01li7150917,
  Token_NUMBER_getInstance as Token_NUMBER_getInstance2xbg3l3gtc5w1,
  Token_STRING_getInstance as Token_STRING_getInstance2zgh44vqhr2y8,
};
//endregion

//# sourceMappingURL=JsonReader.mjs.map
